const countryToRegionMapping = {
  GB: 'Europe',
  FR: 'Europe',
  DE: 'Europe',
  IT: 'Europe',
  NL: 'Europe',
  BR: 'Brazil',
  ES: 'Europe',
  JP: 'Japan',
  PL: 'Europe',
  CL: 'Brazil',
  BE: 'Europe',
  TR: 'Turkey',
  SE: 'Europe',
  CH: 'Europe',
  PE: 'Brazil',
  AR: 'Brazil',
  IN: 'India',
  AT: 'Europe',
  TW: 'India',
  CO: 'Brazil',
  RU: 'Turkey',
  KR: 'Japan',
  NO: 'Europe',
  DK: 'Europe',
  TH: 'India',
  AU: 'Japan',
  FI: 'Europe',
  CN: 'India',
  MY: 'Japan',
  CZ: 'Europe',
  VN: 'India',
  PT: 'Europe',
  ZA: 'Turkey',
  ID: 'India',
  HU: 'Europe',
  HK: 'Japan',
  RO: 'Europe',
  AE: 'Turkey',
  SG: 'India',
  SA: 'Turkey',
  PA: 'Brazil',
  HN: 'Brazil',
  GT: 'Brazil',
  CR: 'Brazil',
  GR: 'Europe',
  SK: 'Europe',
  IL: 'Turkey',
  NZ: 'Japan',
  EG: 'Turkey',
  KZ: 'Turkey',
  EC: 'Brazil',
  IE: 'Europe',
  PH: 'India',
  HR: 'Europe',
  US: 'Brazil',
  MA: 'Turkey',
  IQ: 'Turkey',
  PK: 'Turkey',
  UA: 'Europe',
  SI: 'Europe',
  LU: 'Europe',
};

const getRegionByCountryCode = (countryCode: string): string | undefined => countryToRegionMapping[countryCode];

export default getRegionByCountryCode;
